// RW-245: when the venue lookup fails, "Aggiungilo a mano" opens the manual venue form with the
// name and address of the Google suggestion the employer had picked. Kept apart from the
// components so the rules can be tested without rendering them.

export type VenueSuggestion = { name: string; address: string };

/**
 * The dropdown hands over the suggestion as `${main_text} ${secondary_text}` plus `secondary_text`
 * alone: Google's venue name and its address. Takes the name back out of the joined label.
 */
export const splitGoogleSuggestion = (label?: string, address?: string): VenueSuggestion => {
  const fullLabel = (label || '').trim();
  const venueAddress = (address || '').trim();
  if (!venueAddress || !fullLabel.endsWith(venueAddress)) return { name: fullLabel, address: venueAddress };
  return { name: fullLabel.slice(0, -venueAddress.length).trim(), address: venueAddress };
};

/**
 * Name and address for the manual form, from the Google suggestion the employer picked. Only when
 * that suggestion is the venue being looked up: a venue restored from saved progress or a place id
 * from the URL leaves the suggestion empty or stale, and then the form opens empty, as from the link.
 */
export const getManualEntryPrefill = (
  activeRestaurant: string,
  suggestion: VenueSuggestion
): VenueSuggestion | null => {
  const label = (activeRestaurant || '').trim();
  if (!suggestion.name || !suggestion.address || !label) return null;
  if (!label.startsWith(suggestion.name) || !label.endsWith(suggestion.address)) return null;
  return suggestion;
};
